import { AppRoute } from "modules/routing/types/AppRoute";
import { NewIssue } from "../pages/NewIssue/NewIssue";

export const issuesReportNew = '/issue/new';

export const issuesReportNewRoutes: AppRoute[] = [
    {
        name: 'New-Issue',
        path: issuesReportNew,
        exact: true,
        component: NewIssue
    }
];